<template>
  <el-dialog
    :title="$t('text.edit_facility')"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :show-close="true"
    :modal-append-to-body="true"
    :append-to-body="true"
    @close="closeDialog()"
    width="1000px"
    class="building-and-room-page"
  >
    <BuildingAndRoomStructure @updateBuilding="notifyParent()" />
    <div slot="footer" class="dialog-footer">
      <el-button class="common-btn min-w-80" @click="submit()">{{
        $t('text.save').toUpperCase()
      }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import BuildingAndRoomStructure from '@/components/manage/building/BuildingAndRoomStructure.vue'
export default {
  data() {
    return {
      dialogVisible: false
    }
  },
  components: {
    BuildingAndRoomStructure
  },
  methods: {
    openDialog() {
      this.dialogVisible = true
    },
    closeDialog() {
      this.dialogVisible = false
    },
    submit() {
      this.notifyParent()
      this.closeDialog()
    },
    notifyParent() {
      this.$emit('updateBuilding')
    }
  }
}
</script>
